import { useState } from 'react';

import { FormGroup, MultiselectDropdown } from '@opositandopn/ui';
import { useParams } from 'react-router-dom';
import { useWindowSize } from 'usehooks-ts';

import { Page } from '../../../components/shared/page/Page';
import {
  APTITUDE_SUBJECT_ID,
  ENGLISH_SUBJECT_ID,
  THEORY_SUBJECT_ID,
} from '../../../constants/subjects';
import { DifficultyLevel } from '../../../features/questions/api/useMultipleChoiceQuestions';
import { MultipleChoiceAssessmentAttemptCard } from './MultipleChoiceAssessmentAttemptCard';
import { MultipleChoiceQuestionAttemptCard } from './MultipleChoiceQuestionAttemptCard';

import styles from './MultipleChoiceQuestionnairesPage.module.scss';

function MultipleChoiceQuestionnairesPage() {
  const { subjectId } = useParams();
  const [difficultyLevels, setDifficultyLevels] = useState<DifficultyLevel[]>([
    'easy',
    'medium',
    'hard',
  ]);
  const { width } = useWindowSize();

  return (
    <Page
      title={
        subjectId === THEORY_SUBJECT_ID
          ? 'Teoría'
          : subjectId === APTITUDE_SUBJECT_ID
            ? 'Psicotécnicos'
            : subjectId === ENGLISH_SUBJECT_ID
              ? 'Inglés'
              : undefined
      }
    >
      <FormGroup className={styles['dropdown']}>
        <MultiselectDropdown
          placeholder="Nivel de dificultad..."
          onSelect={(values: (string | number)[]) => {
            setDifficultyLevels(values as DifficultyLevel[]);
          }}
          options={[
            {
              value: 'easy',
              label: 'Fácil',
              selected: difficultyLevels?.includes('easy'),
            },
            {
              value: 'medium',
              label: 'Medio',
              selected: difficultyLevels?.includes('medium'),
            },
            {
              value: 'hard',
              label: 'Difícil',
              selected: difficultyLevels?.includes('hard'),
            },
          ]}
        />
      </FormGroup>
      {width >= 576 && <div />}
      <MultipleChoiceQuestionAttemptCard
        subjectId={subjectId!}
        difficultyLevels={difficultyLevels}
      />
      <MultipleChoiceAssessmentAttemptCard
        subjectId={subjectId!}
        difficultyLevels={difficultyLevels}
      />
    </Page>
  );
}

export { MultipleChoiceQuestionnairesPage };
